<template>
<div>
    <!-- <TheNavigationPanel/> -->
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#08911B" class="headline">Notifications </v-toolbar-title>
        </v-toolbar>
        <v-card class="my-5">
            <!-- claims -->
            <!-- :class="[notifications.is_read ? 'read': '']" -->
        <template>
            <v-data-table
            :headers="notifyHeaders"
            :items="notifications"
            :class="elevation-1"
            class="px-5"
            :items-per-page="5"
            :search="search"
            no-data-text="You don't have any notification"
            >
            <template  v-slot:top>
                <v-toolbar flat color="white">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        color="#08911B"
                        style="width:20%"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br>
            </template>
            <!-- <template v-slot:item.action="{ item }">
                <v-icon
                    style="color:#B45C5C; cursor: pointer;"
                    
                    @click="getClaim(item.link_type_id, item.id)"
                    >
                    mdi-chevron-right
                </v-icon>
            </template> -->
            <template v-slot:body="{ items }">
            <tbody class="hi">
                <tr  v-for="(item) in items" :key="item.name" :class="[item.is_read ? 'read': 'unread']">
                    <td>{{ item.subject }}</td>
                    <td>{{ item.body }}</td>
                    <td>{{ item.date_sent }}</td>
                    <td>
                        <v-icon
                            style="color:#B45C5C; cursor: pointer;"
                            
                            @click="getClaim(item.link_type_id, item.id)"
                            >
                            mdi-chevron-right
                        </v-icon>
                    </td>
                </tr>
            </tbody>
        </template>
            </v-data-table>
        </template>


        <!-- <table class="mail-table">
            <tbody>
            <tr v-for="email in notifications" 
                :key="email.id"
                :class="[email.is_read ? 'read': '']"
                >
                <td>{{email.from}}</td>
                <td>
                <p><strong>{{email.subject}}</strong> - {{email.body}}</p>
                </td>
                <td class="date">{{email.date_sent}}</td>
            </tr>
            </tbody>
        </table> -->
        </v-card>
        
    </div>
    </v-container>

</div>
   
</template>
<script>
    // import TheNavigationPanel from '../components/TheNavigationPanel';

    export default {
        name: 'notifications',
        components: {
            // TheNavigationPanel,
        },

        data: () => ({
            search:'',
            selectedRow: null,
            notifyHeaders: [
                {
                text: 'Subject',
                align: 'left',
                sortable: false,
                value: 'subject',
                class:'font-weight-black'
                },
                {text: 'Body', value:'body', sortable:false},
                {text: 'Date', value:'date_sent', sortable:true},
                { text: '', value: 'action', sortable: false },
            ],
        }),
        computed:{
            notifications(){
                let notify= this.$store.state.notifications.notifications
                for (let j=0; j<notify.length; j++){
                    notify[j].date_sent= notify[j].date_sent.slice(0, 19).replace('T', ' ');
                }
                return notify
            }
        }, 
        created(){
            this.$store.dispatch("getNotifications", {username:this.$store.state.community.logindetails.consultant_id})
            .then(()=>{
            })
            .catch(()=>{
            });
        },
        methods:{
            rowSelect(idx) {
                this.selectedRow = idx;
            },
            getClaim(id, notifyid){
                this.$store.dispatch("updateNotification", {
                    notificationId:notifyid,
                    isRead:1,
                    username:this.$store.state.community.logindetails.consultant_id
                })
                .then((success)=>{
                    this.$store.dispatch("BellCount",this.$store.state.community.logindetails.consultant_id)

                })
                this.$store.dispatch("ViewClaim", id)
                .then((success)=>{
                    this.$router.push(`/claims/${success.claim[0].policy_holder}`)
                })
                .catch(()=>{
                })
            },
            updateNotification(){
                this.$store.dispatch("updateNotification", {
                    notificationId:this.$store.state.notifications.notifications.id,
                    isRead:1,
                    username:this.$store.state.community.logindetails.consultant_id
                })
                .then((success)=>{
                })
                .catch((error)=>{
                })
            },
        }
    }
</script>

<style scoped>
    *{
        font-family: 'Lato';
    }
    .custom-highlight-row{
        background-color: pink
    }
    
</style>